<template>
  <el-row>
    <el-row class="bottom20">
      <el-table ref="table" :data="page.records"
                @selection-change="handleSelectionChange"
      >
        <el-table-column
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column prop="assettype">
          <template slot="header" slot-scope="scope">
            资产类型<br/>
            <dictionary-select v-model="pageSearch.search.assettype" :factory-name="'domain'" :params="'ASSETTYPE'" filterable clearable size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'ASSETTYPE'" :value="scope.row.assettype"></dictionary-text>
          </template>
        </el-table-column>
        <el-table-column prop="description">
          <template slot="header" slot-scope="scope">
            点位类型<br/>
            <el-input v-model="pageSearch.search.description" size="mini"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[5, 15, 25, 50]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </el-row>
</template>

<script>
  import { debounce } from "@/util/common"
  import DomainSelect from '@/components/domainaln'
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import {selected, visited, pageFactory} from  '@/views/workorder/mixins/table'
  import { AssetServer } from  '@/api'
  export default {
    name: "AssetAttrList",
    components: {DomainSelect, DictionarySelect, DictionaryText},
    mixins: [selected, visited, pageFactory({debounce: 200})],
    data() {
      return {
        pageSearch: {
          size: 5,
          search: {
            assettype: '',
            description: '',
          }
        },
        selection: [],
      };
    },
    methods: {
      queryByPage(pageSearch) {
        AssetServer.assetAttribute.page(pageSearch).then((res) => {
          console.log(`asset attribute page`, res);
          if (res.data.code === 200) {
            this.page = {
              total: res.data.data.total,
              records: res.data.data.records,
            };
          }
        });
      },
      handleSelectionChange(val) {
        this.selection = val;
        this.$emit('selection-change', val);
      },
      clear() {
        this.pageSearch.search.assettype = '';
        this.pageSearch.search.description = '';
        this.$refs['table'].clearSelection();
      }
    },
  }
</script>

<style scoped>

</style>